import { lazy } from 'react';
import { Route } from 'react-router-dom';

const VipCreator = lazy(() => import('../components/vip-creator/index'));
const Dashboard = lazy(() => import('../creator-dashboard/Dashboard.jsx'));
const Allitems = lazy(() => import('../creator-dashboard/Allitems.jsx'));
const BrandDeals = lazy(() => import('../creator-dashboard/BrandDealStatus.jsx'));
const Lottery = lazy(() => import('../creator-dashboard/Lottery.jsx'));
const PostCreationIncentive = lazy(() => import('../components/post-creation-incentive/index'));

const creatorRoutes = (
	<>
		<Route path="/creator-dashboard" element={<VipCreator />} />
		<Route path="/creator-dashboard/v1" element={<Dashboard />} />
		<Route path="/creator-dashboard/viewAll" element={<Allitems />} />
		<Route path="/creator-dashboard/brand-deals" element={<BrandDeals />} />
		<Route path="/creator-dashboard/lottery" element={<Lottery />} />
		<Route path="/vip-creator" element={<VipCreator />} />
		<Route path="/post-creation" element={<PostCreationIncentive />} />
	</>
);

export default creatorRoutes;
